export const DownArrowIcon = () => (
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_78_340)">
      <path
        d="M8.50002 9.32998L12.0063 5.82373L13.0079 6.82531L8.50002 11.3331L3.99219 6.82531L4.99377 5.82373L8.50002 9.32998Z"
        fill="#6C6F71"
      />
    </g>
    <defs>
      <clipPath id="clip0_78_340">
        <rect width="17" height="17" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export const DownArrowIconBlue = ({ fill }: { fill?: string }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 13.172L16.95 8.222L18.364 9.636L12 16L5.63599 9.636L7.04999 8.222L12 13.172Z"
      fill={fill || "#A7C7EA"}
    />
  </svg>
);
export const LeftArrowBlue = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_404_6206)">
      <path
        d="M16.172 11.0002H4V13.0002H16.172L10.808 18.3642L12.222 19.7782L20 12.0002L12.222 4.22217L10.808 5.63617L16.172 11.0002Z"
        fill="url(#paint0_linear_404_6206)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_404_6206"
        x1="19.3743"
        y1="5.10033"
        x2="-2.86591"
        y2="8.41233"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#2977CC" />
        <stop offset="1" stop-color="#1D538F" />
      </linearGradient>
      <clipPath id="clip0_404_6206">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="matrix(-1 0 0 1 24 0)"
        />
      </clipPath>
    </defs>
  </svg>
);
export const DownArrowIconBlueLIne = () => (
  <svg
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_413_8009)">
      <path
        d="M11.9171 17.52L11.9171 4.33366L14.0837 4.33366L14.0837 17.52L19.8947 11.709L21.4266 13.2408L13.0004 21.667L4.57422 13.2408L6.10605 11.709L11.9171 17.52Z"
        fill="url(#paint0_linear_413_8009)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_413_8009"
        x1="5.52556"
        y1="20.9892"
        x2="9.11356"
        y2="-3.10441"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#2977CC" />
        <stop offset="1" stop-color="#1D538F" />
      </linearGradient>
      <clipPath id="clip0_413_8009">
        <rect
          width="26"
          height="26"
          fill="white"
          transform="translate(0 26) rotate(-90)"
        />
      </clipPath>
    </defs>
  </svg>
);
export const UpArrowFill = () => (
  <svg
    width="8"
    height="4"
    viewBox="0 0 8 4"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M4 0L8 4H0L4 0Z" fill="#6C7687" />
  </svg>
);
export const AddIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.25 8.25V5.25H9.75V8.25H12.75V9.75H9.75V12.75H8.25V9.75H5.25V8.25H8.25ZM9 16.5C4.85775 16.5 1.5 13.1422 1.5 9C1.5 4.85775 4.85775 1.5 9 1.5C13.1422 1.5 16.5 4.85775 16.5 9C16.5 13.1422 13.1422 16.5 9 16.5ZM9 15C10.5913 15 12.1174 14.3679 13.2426 13.2426C14.3679 12.1174 15 10.5913 15 9C15 7.4087 14.3679 5.88258 13.2426 4.75736C12.1174 3.63214 10.5913 3 9 3C7.4087 3 5.88258 3.63214 4.75736 4.75736C3.63214 5.88258 3 7.4087 3 9C3 10.5913 3.63214 12.1174 4.75736 13.2426C5.88258 14.3679 7.4087 15 9 15V15Z"
      fill="white"
    />
  </svg>
);
export const SearchIcon = () => (
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_1942_26177)">
      <path
        d="M12.772 11.7707L15.8058 14.8038L14.8035 15.8061L11.7704 12.7723C10.6418 13.677 9.2381 14.169 7.79169 14.167C4.27269 14.167 1.41669 11.311 1.41669 7.79199C1.41669 4.27299 4.27269 1.41699 7.79169 1.41699C11.3107 1.41699 14.1667 4.27299 14.1667 7.79199C14.1687 9.23841 13.6767 10.6421 12.772 11.7707ZM11.3511 11.2451C12.25 10.3207 12.7521 9.08146 12.75 7.79199C12.75 5.05216 10.5308 2.83366 7.79169 2.83366C5.05185 2.83366 2.83335 5.05216 2.83335 7.79199C2.83335 10.5311 5.05185 12.7503 7.79169 12.7503C9.08116 12.7524 10.3204 12.2503 11.2448 11.3514L11.3511 11.2451Z"
        fill="#6C6F71"
      />
    </g>
    <defs>
      <clipPath id="clip0_1942_26177">
        <rect width="17" height="17" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export const DeleteIconTable = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15 4H20V6H18V19C18 19.2652 17.8946 19.5196 17.7071 19.7071C17.5196 19.8946 17.2652 20 17 20H3C2.73478 20 2.48043 19.8946 2.29289 19.7071C2.10536 19.5196 2 19.2652 2 19V6H0V4H5V1C5 0.734784 5.10536 0.48043 5.29289 0.292893C5.48043 0.105357 5.73478 0 6 0H14C14.2652 0 14.5196 0.105357 14.7071 0.292893C14.8946 0.48043 15 0.734784 15 1V4ZM16 6H4V18H16V6ZM7 9H9V15H7V9ZM11 9H13V15H11V9ZM7 2V4H13V2H7Z"
      fill="#F44336"
    />
  </svg>
);

export const AdminEditIconTable = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5 19.0001H6.414L15.728 9.68608L14.314 8.27208L5 17.5861V19.0001ZM21 21.0001H3V16.7571L16.435 3.32208C16.6225 3.13461 16.8768 3.0293 17.142 3.0293C17.4072 3.0293 17.6615 3.13461 17.849 3.32208L20.678 6.15108C20.8655 6.33861 20.9708 6.59292 20.9708 6.85808C20.9708 7.12325 20.8655 7.37756 20.678 7.56508L9.243 19.0001H21V21.0001ZM15.728 6.85808L17.142 8.27208L18.556 6.85808L17.142 5.44408L15.728 6.85808Z" fill="url(#paint0_linear_3000_4903)"/>
<defs>
<linearGradient id="paint0_linear_3000_4903" x1="3.70391" y1="4.04378" x2="28.7522" y2="7.67634" gradientUnits="userSpaceOnUse">
<stop stop-color="#2977CC"/>
<stop offset="1" stop-color="#1D538F"/>
</linearGradient>
</defs>
</svg>
);
export const EditIconTable = () => (
  <svg
    width="31"
    height="30"
    viewBox="0 0 31 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="31" height="30" rx="6" fill="#EAF1FA" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.30722 16.5978L17.3827 8.68182C18.4217 7.66335 20.1069 7.66335 21.1459 8.68182L22.2245 9.73913C23.2635 10.7576 23.2635 12.4095 22.2245 13.428L14.1172 21.3751C13.6536 21.8296 13.0251 22.0846 12.369 22.0846H9.04878C8.74035 22.0846 8.49249 21.8355 8.50017 21.5332L8.58369 18.2492C8.6003 17.6285 8.85939 17.0367 9.30722 16.5978ZM21.4484 10.4995L20.3697 9.44222C19.7594 8.84391 18.7691 8.84391 18.1587 9.44222L17.5316 10.057L20.8215 13.2813L21.4484 12.6669C22.0587 12.0685 22.0587 11.0978 21.4484 10.4995ZM10.0833 17.3582L16.7555 10.8177L20.0455 14.042L13.341 20.614L13.2519 20.6941C13.0055 20.8963 12.6935 21.0083 12.369 21.0083L9.61117 21.0079L9.68085 18.2763C9.69007 17.9317 9.83434 17.6022 10.0833 17.3582Z"
      fill="#2977CC"
    />
    <path
      d="M23.5 21.5445C23.5 21.2474 23.2543 21.0065 22.9513 21.0065H17.2259L17.1514 21.0114C16.8835 21.047 16.6771 21.2721 16.6771 21.5445C16.6771 21.8415 16.9228 22.0824 17.2259 22.0824H22.9513L23.0257 22.0775C23.2936 22.0419 23.5 21.8168 23.5 21.5445Z"
      fill="#2977CC"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.30722 16.5978L17.3827 8.68182C18.4217 7.66335 20.1069 7.66335 21.1459 8.68182L22.2245 9.73913C23.2635 10.7576 23.2635 12.4095 22.2245 13.428L14.1172 21.3751C13.6536 21.8296 13.0251 22.0846 12.369 22.0846H9.04878C8.74035 22.0846 8.49249 21.8355 8.50017 21.5332L8.58369 18.2492C8.6003 17.6285 8.85939 17.0367 9.30722 16.5978ZM21.4484 10.4995L20.3697 9.44222C19.7594 8.84391 18.7691 8.84391 18.1587 9.44222L17.5316 10.057L20.8215 13.2813L21.4484 12.6669C22.0587 12.0685 22.0587 11.0978 21.4484 10.4995ZM10.0833 17.3582L16.7555 10.8177L20.0455 14.042L13.341 20.614L13.2519 20.6941C13.0055 20.8963 12.6935 21.0083 12.369 21.0083L9.61117 21.0079L9.68085 18.2763C9.69007 17.9317 9.83434 17.6022 10.0833 17.3582Z"
      stroke="#2977CC"
      stroke-width="0.55102"
    />
    <path
      d="M23.5 21.5445C23.5 21.2474 23.2543 21.0065 22.9513 21.0065H17.2259L17.1514 21.0114C16.8835 21.047 16.6771 21.2721 16.6771 21.5445C16.6771 21.8415 16.9228 22.0824 17.2259 22.0824H22.9513L23.0257 22.0775C23.2936 22.0419 23.5 21.8168 23.5 21.5445Z"
      stroke="#2977CC"
      stroke-width="0.55102"
    />
  </svg>
);
export const UpArrowGreen = () => (
  <svg
    width="8"
    height="4"
    viewBox="0 0 8 4"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M4.05904 3.67L0.389038 0H7.72904L4.05904 3.67Z" fill="#4CAF50" />
  </svg>
);
export const UpArrowInactive = () => (
  <svg
    width="8"
    height="4"
    viewBox="0 0 8 4"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M4.05904 3.67L0.389038 0H7.72904L4.05904 3.67Z" fill="#F44336" />
  </svg>
);

export const ArrowRightCircleIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_1942_19688)">
      <path
        d="M12 11V8L16 12L12 16V13H8V11H12ZM12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2ZM12 20C16.42 20 20 16.42 20 12C20 7.58 16.42 4 12 4C7.58 4 4 7.58 4 12C4 16.42 7.58 20 12 20Z"
        fill="#2977CC"
      />
    </g>
    <defs>
      <clipPath id="clip0_1942_19688">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
